<script lang="ts">
  export let discount;
</script>

<style lang="scss">
  // Import theme colours
  @use "sass/user/colours";
  .border-dashed {
    border: 1px dashed colours.$primary !important;
    flex-grow: 1;
  }
</style>

<div class="row no-gutters">
  <div
    class="col-12 d-flex align-items-center justify-content-center rounded-left
    border border-dashed rounded color-primary">
    <div class="text-xl text-primary">{discount}% OFF</div>
  </div>
</div>
